import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async ({ daiChatId, ...params }) => {
  return await dponetAPI.post(`/dai_chats/${daiChatId}/messages`, params)
}

export default {
  create,
}
